/* eslint-disable no-restricted-syntax */
/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useIntl } from '@exo/frontend-common-i18n';
import { FormTop } from '@exo/frontend-components-insurance';
import { AuthEndpointsConfig } from '../../authConfig';
import { PolarisLoginComponent } from '../../components/PolarisLoginComponent/PolarisLoginComponent';
import * as S from './LoginPage.styles';

export const LoginPage = ({authConfig}: Props) => {
  const intlPrefix = 'features.polaris-login.polaris-login-ui.pages.LoginPage'
  const intl = useIntl(intlPrefix)
  const loginEndpoint = authConfig?.login
  const registerUrl = `${authConfig?.mainAppUrl}/register/register-intro`
  return (
    <S.LoginPageContainer>
      <S.LoginFormContainer>
        <PolarisLoginComponent intlPrefix={intlPrefix} loginEndpoint={loginEndpoint}/>
      </S.LoginFormContainer>
      <S.LoginTextContainer>
        <S.FormTopWrapper>
          <FormTop title={intl.msg('title', "New Users")}></FormTop>
        </S.FormTopWrapper>

        <S.LoginTextContent>
          <S.LoginTextSubtitle>{intl.msg('subtitle', 'Welcome to imarket')}</S.LoginTextSubtitle>
          {intl.msg('description', 'Creating an account only takes a few moments. You will be able to store your details and receive notifications from Polaris.')}
        </S.LoginTextContent>
        <a href={registerUrl} className='cta'>{intl.msg('register', 'Register')}</a>
      </S.LoginTextContainer>
    </S.LoginPageContainer>
  );
};

type Props = {
  authConfig: AuthEndpointsConfig;
};
